import React from "react";
import { Check, Calendar, FileText, MessageCircle } from "lucide-react";
import { formatDate, WHATSAPP_PHONE } from "./constants";

export default function SuccessView({ selectedType, selectedDate, selectedSlot, navigate }) {
  return (
    <div className="text-center py-12" data-testid="step-success">
      <div className="w-20 h-20 mx-auto mb-6 border-2 border-emerald_deep rounded-full flex items-center justify-center">
        <Check size={32} className="text-emerald_deep" />
      </div>
      <h2 className="font-serif text-3xl text-emerald_deep mb-4">Payment Successful!</h2>
      <p className="text-text_muted mb-2">Your {selectedType?.title} booking has been received.</p>
      {selectedDate && (
        <p className="text-sm text-accent font-semibold mb-6">
          Preferred: {formatDate(selectedDate)} at {selectedSlot}
        </p>
      )}
      <div className="bg-emerald_deep/5 border border-emerald_deep/15 p-6 max-w-md mx-auto mb-4 rounded-xl">
        <Calendar size={20} className="text-emerald_deep mx-auto mb-3" />
        <p className="text-sm text-emerald_deep font-semibold mb-2">What Happens Next?</p>
        <p className="text-sm text-text_muted">Our team will confirm if your preferred slot is available, or suggest the next earliest slot. You&apos;ll receive a confirmation via WhatsApp and email.</p>
      </div>
      <div className="bg-surface border border-border_custom p-4 max-w-md mx-auto mb-8 rounded-xl">
        <FileText size={16} className="text-accent mx-auto mb-2" />
        <p className="text-xs text-text_muted">Please share your medical reports at least <span className="text-accent font-semibold">1 day before</span> your consultation via WhatsApp.</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button onClick={() => navigate("/")} data-testid="go-home-btn"
          className="border border-border_custom text-emerald_deep px-8 py-3 text-sm tracking-wide hover:bg-bone transition-all rounded-full">Back to Home</button>
        <a href={`https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent("Hi! I just booked a consultation on Fitly India. Looking forward to the slot confirmation!")}`}
          target="_blank" rel="noopener noreferrer" data-testid="whatsapp-schedule-btn"
          className="bg-emerald_deep text-bone px-8 py-3 text-sm tracking-wide hover:bg-emerald_deep/90 transition-all flex items-center justify-center gap-2 rounded-full">
          <MessageCircle size={16} /> Message on WhatsApp
        </a>
      </div>
    </div>
  );
}
